module.exports = __webpack_public_path__ + "media/images/logos/tc-logo-small-0f32eb9391b103849182e85106492a31.svg";